<template>
  <v-dialog v-model="open" persistent :max-width="maxWidth">
    <v-card class="d-flex flex-column">
      <v-card-text class="px-8 pt-6">
        <slot v-bind="{ message }">
          <p class="text-h6 font-weight-regular">{{ message }}</p>
        </slot>
      </v-card-text>
      <v-card-actions class="justify-end px-8 pb-6">
        <v-spacer></v-spacer>
        <v-btn color="primary" text small dense @click="close(false)">
          {{ cancelButtonLabel }}
        </v-btn>
        <v-btn color="primary" small dense @click="close(true)">
          {{ confirmButtonLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    cancelButtonLabel: {
      type: String,
      default: 'cancelar',
    },
    confirmButtonLabel: {
      type: String,
      default: 'confirmar',
    },
    maxWidth: {
      type: [Number, String],
      default: 480,
    },
  },
  data() {
    return {
      open: false,
      message: '',
      promise: null,
    }
  },
  methods: {
    async confirm(message) {
      if (this.promise) {
        return this.promise.reject(
          new Error(
            `A new dialog with message '${message}' opened on top of a previous one with message '${this.message}'`,
          ),
        )
      }

      this.message = message
      this.open = true
      return new Promise((resolve, reject) => {
        this.promise = { resolve, reject }
      })
    },
    close(result) {
      this.open = false
      this.promise.resolve(result)
      this.promise = null
    },
  },
  beforeDestroy() {
    if (this.promise) {
      this.promise.reject(new Error(`Confirm dialog component with message '${this.message}' destroyed...`))
      this.promise = null
    }
  },
}
</script>

<style scoped></style>
